import React from 'react'
import './BrandAssets.css'

import logo192 from './assets/logo-192x192.png'
import logo192Reverse from './assets/logo-192x192-reverse.png'

import badge from './assets/badge.png'
import badgeReverse from './assets/badge-reverse.png'

export default function BrandAssets() {
  return (
    <div className="ba-page">
      <div className="ba-shell">

        {/* HERO */}
        <section className="ba-hero">
          <div className="ba-hero-copy">
            <span className="ba-kicker">Brand Assets</span>
            <h1 className="ba-title brand-dark-purple">Brand assets</h1>
            {/* <p className="ba-text">
              Find approved logos and brand assets for press, partners, and approved placements.
            </p> */}
          </div>

          <div className="ba-hero-actions">
            <a href="#logos" className="lp-btn brand-purple-inline">View logos</a>
            <a href="#badges" className="lp-btn brand-purple-outline">Website badge</a>
          </div>
        </section>

        {/* LOGOS */}
        <section className="ba-section" id="logos">
          <div className="ba-section-head">
            <div>
              <h2 className="ba-section-title brand-dark-purple">Logos</h2>
              <p className="ba-section-text">
                Official logo files for light and dark placements.
              </p>
            </div>
          </div>

          <div className="ba-grid ba-grid-2">

            <div className="ba-card">
              <div className="ba-logo-preview ba-logo-light">
                <img src={logo192} alt="Primary logo" className="ba-logo-image ba-logo-small" />
              </div>

              <div className="ba-card-body">
                <h3 className="ba-card-title">Primary logo</h3>
                <p className="ba-card-text">
                  Main version for light backgrounds.
                </p>

                <div className="ba-card-actions">
                  <a
                    href={logo192}
                    download="logo-192x192.png"
                    className="lp-btn brand-purple-inline"
                  >
                    Download PNG
                  </a>
                </div>
              </div>
            </div>

            <div className="ba-card">
              <div className="ba-logo-preview ba-logo-dark">
                <img src={logo192Reverse} alt="Reverse logo" className="ba-logo-image ba-logo-small" />
              </div>

              <div className="ba-card-body">
                <h3 className="ba-card-title">Reverse logo</h3>
                <p className="ba-card-text">
                  Reverse version for dark backgrounds.
                </p>

                <div className="ba-card-actions">
                  <a
                    href={logo192Reverse}
                    download="logo-192x192-reverse.png"
                    className="lp-btn brand-purple-inline"
                  >
                    Download PNG
                  </a>
                </div>
              </div>
            </div>

          </div>
        </section>

        {/* BADGES */}
        <section className="ba-section" id="badges">
          <div className="ba-section-head">
            <div>
              <h2 className="ba-section-title brand-dark-purple">Website badge</h2>
              <p className="ba-section-text">
                Use this badge on your website to show you're listed on Neuro Therapy Directory.
              </p>
            </div>
          </div>

          <div className="ba-grid ba-grid-2">

            <div className="ba-card">
              <div className="ba-logo-preview ba-logo-light">
                <img src={badge} alt="Badge" className="ba-logo-image" />
              </div>

              <div className="ba-card-body">
                <h3 className="ba-card-title">Light version</h3>
                <p className="ba-card-text">
                  Use on light backgrounds.
                </p>

                <div className="ba-card-actions">
                  <a
                    href={badge}
                    download="badge.png"
                    className="lp-btn brand-purple-inline"
                  >
                    Download PNG
                  </a>
                </div>
              </div>
            </div>

            <div className="ba-card">
              <div className="ba-logo-preview ba-logo-dark">
                <img src={badgeReverse} alt="Reverse badge" className="ba-logo-image" />
              </div>

              <div className="ba-card-body">
                <h3 className="ba-card-title">Dark version</h3>
                <p className="ba-card-text">
                  Use on dark or coloured backgrounds.
                </p>

                <div className="ba-card-actions">
                  <a
                    href={badgeReverse}
                    download="badge-reverse.png"
                    className="lp-btn brand-purple-inline"
                  >
                    Download PNG
                  </a>
                </div>
              </div>
            </div>

          </div>
        </section>

        {/* COLOURS */}
        <section className="ba-section" id="colours">
          <div className="ba-card ba-card-soft">
            <div className="ba-card-body">
              <h2 className="ba-section-title brand-dark-purple">Brand colours</h2>
              <p className="ba-section-text">Core colours for approved brand use.</p>

              <div className="ba-swatches">

                <div className="ba-swatch">
                  <div className="ba-swatch-chip ba-swatch-primary"></div>
                  <div>
                    <div className="ba-swatch-name">Primary Purple</div>
                    <div className="ba-swatch-code">#6e4daa</div>
                  </div>
                </div>

                <div className="ba-swatch">
                  <div className="ba-swatch-chip ba-swatch-dark"></div>
                  <div>
                    <div className="ba-swatch-name">Dark Purple</div>
                    <div className="ba-swatch-code">#2c1b45</div>
                  </div>
                </div>

                <div className="ba-swatch">
                  <div className="ba-swatch-chip ba-swatch-soft"></div>
                  <div>
                    <div className="ba-swatch-name">Soft Background</div>
                    <div className="ba-swatch-code">#fbf8ff</div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>

      </div>
    </div>
  )
}